import BaseService from "./BaseService";
import { toast, Notification } from "components/ui";

// Tracks error messages currently on screen so repeated clicks that trigger the
// same validation error do not stack identical toasts. The key is released after
// the toast's own duration so the message can be shown again once it disappears.
const ERROR_TOAST_DURATION = 4000;
const activeErrorToasts = new Set();

const pushErrorToast = (title, message) => {
  if (activeErrorToasts.has(message)) {
    return;
  }
  activeErrorToasts.add(message);
  toast.push(
    <Notification title={title} type="danger" duration={ERROR_TOAST_DURATION}>
      {message}
    </Notification>,
    {
      placement: "top-center",
    }
  );
  setTimeout(() => activeErrorToasts.delete(message), ERROR_TOAST_DURATION);
};

const ApiService = {
  fetchData(param) {
    return new Promise((resolve, reject) => {
      BaseService(param)
        .then((response) => {
          resolve(response);

          
          const method = (param?.method || "get").toLowerCase();
          const isMutation = ["post", "put", "patch", "delete"].includes(method);

          if (
            isMutation &&
            (response?.data?.message || response?.data?.response) &&
            response?.data?.succeeded !== false
          ) {
            const message =
              typeof response?.data?.message === "string"
                ? response.data.message
                : typeof response?.data?.response === "string"
                ? response.data.response
                : "";

            const isSingleService = message
              .toLowerCase()
              .startsWith("single service") || message.toLowerCase().startsWith("service item added")

            if (!isSingleService) {
              toast.push(
                <Notification
                  title="Successfully Done"
                  type="success"
                  duration={2500}
                >
                  {message || "Operation completed successfully"}
                </Notification>,
                {
                  placement: "top-center",
                }
              );
            }
          }
        })
        .catch((errors) => {
          console.log(errors);
          const errorResponse = errors.response?.data;

          if (errorResponse) {
            // A plain-string body (our APIs return BadRequest(err.Message))
            // carries the real reason — surface it instead of a generic message.
            const stringBody =
              typeof errorResponse === "string" ? errorResponse : null;

            const errorTitle = errorResponse.title || "Validation Error";

            // Extract the validation error details
            const validationErrors = errorResponse.errors;
            const errorMessages = validationErrors
              ? Object.entries(validationErrors)
                  .map(([, messages]) =>
                    Array.isArray(messages) ? messages.join(", ") : String(messages)
                  )
                  .join(" | ")
              : stringBody || errorResponse.message || "An unexpected error occurred.";

            // Callers that show their own error toast can opt out of this global one.
            if (!param?.skipGlobalErrorToast) {
              pushErrorToast(errorTitle, errorMessages);
            }
          } else {
            // Default error message for unexpected issues
            if (!param?.skipGlobalErrorToast) {
              pushErrorToast("Error", "An unexpected error occurred.");
            }
          }

          // Reject with the real server message (plain-string body or .message) so
          // callers can display it, falling back to the title / a generic string.
          const rejectionMessage =
            (typeof errorResponse === "string" && errorResponse) ||
            errorResponse?.message ||
            errorResponse?.title ||
            "An unexpected error occurred.";
          reject(rejectionMessage);
        });
    });
  },
};

export default ApiService;
